import api from "./api";

export function exportSpreadsheetArray(data) {
  return async (dispatch, getState) =>
    await api.export(getState().user.user.credentials, data);
}
